import React, { useEffect } from 'react'
import ModifierTable from '../../Components/ModifierTable/page'
import Banner2 from '../../Components/Banner/Banner2'

const Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    <Banner2 title="WELCOME TO MODIFIED TOUR" backgroundImage="/assets/images/banner/video-banner-1.jpg"/>
    {/* <DriverSec3/> */}
    <ModifierTable/>
    </>
  )
}

export default Page